/* eslint-disable */
import React, { useMemo } from 'react';
import ModernNode from "./CustomNode/ModernNode";

function FilterNodes(props) {
    const {
        data = [],
        sortOrder = 'asc',
        handlers = {},
        renderNode,
        containerClassName = 'w-full h-full overflow-auto p-4 mt-14',
        gridClassName = 'flex flex-wrap gap-x-4 gap-y-14 justify-start pt-14 pl-20',
        nodeZoom = 0.13,
        isProductJourney = false,
        ...restProps
    } = props;

    const sortedData = useMemo(() => {
        if (!data?.length) return [];
        return [...data].sort((a, b) => {
            if (isProductJourney) {
                const orderA = a?.displayOrder ?? 0;
                const orderB = b?.displayOrder ?? 0;
                return orderA - orderB;
            } else {
                const scoreA = a?.score ?? 0;
                const scoreB = b?.score ?? 0;
                return scoreB - scoreA;
            }
        });
    }, [data, isProductJourney]);

    return (
        <div className={containerClassName}>
            <div className={gridClassName}>
                {sortedData?.map((node) => (
                    <div key={node.id} style={{ zoom: nodeZoom }}>
                        {renderNode ? (
                            renderNode(node, handlers)
                        ) : (
                            <ModernNode
                                {...restProps}
                                {...handlers}
                                id={node.id}
                                data={node.data}
                                isProductJourney={isProductJourney}
                                customConfig={{
                                    showHandles: false,
                                }}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default FilterNodes;
